module.exports = __webpack_public_path__ + "static/media/icon-warning-yellow.1dd53c1d.svg";